module.exports = __webpack_public_path__ + "d41250f1dfa08e056926dad6398e9794.png";